import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import * as actions from '../../actions';

import MainTemplatePanel from './MainTemplatePanel';


class AddTemplatePanel extends Component {
  componentDidMount() {
    const { selectHome } = this.props;
    selectHome();
  }


  componentWillUnmount() {
    const { resetHotkeyTemplate } = this.props;
    resetHotkeyTemplate();
  }


  render() {
    return (
      <MainTemplatePanel />
    );
  }

}


function mapDispatchToProps(dispatch) {
  const { selectHome, resetHotkeyTemplate } = actions;

  return bindActionCreators({
    selectHome,
    resetHotkeyTemplate
  }, dispatch);
}


export default connect(null, mapDispatchToProps)(AddTemplatePanel);
